import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    problem: '3 hs buscando protocolos × 40 semanas',
    cost: '120 horas de tu vida por año'
  }, {
    problem: 'Fichas sin tracker de progresión',
    cost: 'Pacientes que abandonan sin ver resultados'
  }, {
    problem: 'Protocolos inventados en el momento',
    cost: 'Riesgo clínico + desgaste profesional'
  }, {
    problem: 'Sin sistema de retorno deportivo',
    cost: 'Pacientes que recaen y no vuelven'
  }, {
    problem: 'Semana buscando en Google',
    cost: 'El mismo ciclo, el próximo año'
  }];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-52">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-54">
          {/* Header */}
          <div className="text-center mb-6 md:mb-12" data-id="element-55">
            <div className="flex justify-center mb-4 md:mb-6" data-id="element-56">
              <div className="bg-red-500/10 p-4 rounded-full" data-id="element-57">
                <Scale className="w-12 h-12 text-red-500" data-id="element-58" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2 md:mb-4" data-id="element-59">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          {/* Cost Table */}
          <div className="bg-[#0f1f17] border border-red-900/30 rounded-lg overflow-hidden mb-6 md:mb-10" data-id="element-60">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-[#0a1410] border-b border-red-900/30" data-id="element-61">
              <div className="font-bold text-white" data-id="element-62">Sin el Atlas</div>
              <div className="font-bold text-red-500" data-id="element-63">Costo real</div>
            </div>

            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border-b border-red-900/20 last:border-b-0" data-id="element-64">
                <div className="text-gray-300" data-id="element-65">{item.problem}</div>
                <div className="text-red-400 font-semibold" data-id="element-66">{item.cost}</div>
              </motion.div>)}
          </div>

          {/* Closing Statement */}
          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-amber-500 text-center" data-id="element-67">
            La próxima semana puede ser diferente.
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}